package com.exura.features.localization.domain.model

enum class Language {
    POLISH, ENGLISH
}